import { Rating, Label, InputField, Callout, Checkbox, SwitchToggle, Tooltip, EventHandler } from "client/CommonComponents";
import './AssetDetail.scss'
import { CONSTANTS } from "client/utils/constants";
import CancelConfirmationPopup from "client/CommonComponents/DialogBox/CancelConfirmationPopup";
import Moment from 'moment';
import { formatLableValue, formatPrice, getBooleanYesNo } from "utils";
import { isAuthorized } from "client/utils/Permissions";
import { FLEET_PROCESSING_PERMISSIONS } from "client/utils/constants/fleetProcessingPermissions";

const AssetDetail = (props: any) => {
    const {
        assetDetails,
        orderType,
        onChangeAssetDetermination,
        isAttachmentBtnClicked,
        onClicktLinkAttachment,
        onCloseLinkAttachment,
        getLinkedAttachmentsCount,
        linkedAttachments,
        attachmentsList,
        onChangeLinkAttachment,
        onClickAttachment,
        onChangeNewAsset,
        onBlurNewAsset,
        Popupcontent,
        hideConfirmationDialog,
        newAssetError,
        savedStatus,
        newAssetErrorCheck,
        isSuperAdmin,
        handleOverridePenaltyFeeChange,
        handleOverridePenaltyCommentChange,
        onBlurOverridePenaltyComment,
        penaltyCommentError
    } = props;
    let isRequisitionComplete = savedStatus?.filter((saveItem: any) => (saveItem?.fleetItemId == assetDetails?.fleetRequestDetailId))?.[0]
    const ReceivingIssuesList =( receivingIssues : any) => {
        return (
          <ul className="recievingissues_list">
            {receivingIssues.map((issue : any, index : any) =>(
              <li key={index}>{issue}</li>
            ))}
          </ul>
        );
    };

    const getAttachmentView = (itemType: any, index: any) => {
        let val = itemType?.filter((item?: any) => item?.fleetItemId == assetDetails?.fleetRequestDetailId)
        return (
            <div className="tooltip-container">
                <div className='header'>
                    <EventHandler onEvent={(e:any)=>onCloseLinkAttachment(e)} data-attribute="AssetDetail_Default_EventHandler">
                        <img src="close" alt="" />
                    </EventHandler>
                </div>
                <div className='content'>
                    <div className="checkbox-list-container p-0">
                        {
                            attachmentsList?.length ? attachmentsList?.map((attachment: any) => {
                                const filteredArr = linkedAttachments?.filter((x: any) => x?.fleetItemId == assetDetails?.fleetRequestDetailId)
                                let isAlreadyExist = filteredArr[0]?.attachments?.filter((item?: any) => (item?.fileName == attachment.fileName && (!item?.isFleet && item?.isFleet != undefined)))
                                const extensionList = ['jpg', 'jpeg', 'jfif', 'png', 'gif', 'txt', 'bmp', 'webp', 'pdf', 'xlsx', 'heif', 'hevc'];
                                const indexExt = attachment?.fileName.lastIndexOf('.');
                                const extension = attachment?.fileName.slice(indexExt + 1);
                                return (
                                    <div key={attachment?.fileName} className='checkbox-container'>
                                        <Checkbox
                                            className={"checkbox"}
                                            disabled={isAlreadyExist?.length || isRequisitionComplete?.itemStatus == CONSTANTS.ORDER_STATUS.TRANSFER_COMPLETE || assetDetails?.itemStatus == CONSTANTS.ORDER_STATUS.TRANSFER_COMPLETE || isRequisitionComplete?.itemStatus == CONSTANTS.ORDER_STATUS.REACTIVATION_COMPLETE || assetDetails?.itemStatus == CONSTANTS.ORDER_STATUS.REACTIVATION_COMPLETE || isRequisitionComplete?.itemStatus == CONSTANTS.ITEM_STATUS.DISPOSITION_COMPLETE || assetDetails?.itemStatus == CONSTANTS.ITEM_STATUS.DISPOSITION_COMPLETE || assetDetails?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || assetDetails?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || assetDetails?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || isRequisitionComplete?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS) ? true : false}
                                            title={attachment?.fileName}
                                            defaultChecked={isAlreadyExist?.length ? true : val ? val[0]?.attachments?.map((x: any) => x.fileName).includes(attachment.fileName) : false}
                                            onChange={(e: any) => { onChangeLinkAttachment(e, attachment, val) }}
                                         data-attribute="AssetDetail_Default_Checkbox" />
                                        {extensionList.includes(extension.toString().toLowerCase()) ?
                                            <EventHandler onEvent={() => { onClickAttachment(attachment?.attachmentUrl) }} data-attribute={`AssetDetail_${(attachment?.fileName || attachment?.attachmentUrl).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_EventHandler`}>
                                                <div className='left-block'>
                                                    <a className='attachment-list'>{attachment?.fileName}</a>
                                                    <div className='pull-right'></div>
                                                </div>
                                            </EventHandler>
                                            :
                                            <div className='left-block'>
                                                <a href={attachment?.attachmentUrl}>{attachment?.fileName}</a>
                                                <div className='pull-right'></div>
                                            </div>
                                        }
                                    </div>)
                            }) :
                                <div className='checkbox-container text-center'>
                                    No Attachment
                                </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
    const attachmentBlock = () => {
        return(<>
            <EventHandler onEvent={(e: any) => { onClicktLinkAttachment(e, assetDetails?.fleetRequestDetailId) }} data-attribute="AssetDetail_Default_EventHandler_3">
                <span
                    className='link-attachment anchorLink me-0 mb-2' id={`link_attachment_${assetDetails?.fleetRequestDetailId}`}>
                    <span className='fa fa-paperclip attachment-img  pe-1'> </span>
                    Link Attachment to Item
                    ({getLinkedAttachmentsCount(linkedAttachments)})
                </span>
            </EventHandler>
            {isAttachmentBtnClicked?.[assetDetails?.fleetRequestDetailId] && (<Callout
                targetId={`link_attachment_${assetDetails?.fleetRequestDetailId}`}
                toggleIsCalloutVisible={(e: any) => { onClicktLinkAttachment(e, assetDetails?.fleetRequestDetailId) }}
                calloutMaxHeight={300}
             data-attribute="AssetDetail_Default_Callout">
                {getAttachmentView(linkedAttachments, assetDetails?.fleetRequestDetailId)}
            </Callout>)
            }
        </>)
    }

    let isNewAssetErrorExist =  orderType === CONSTANTS.REACTIVATION ? newAssetError?.length ? newAssetError?.filter((item?: any) => item?.fleetId == assetDetails?.fleetRequestDetailId) : [] : []
    return (<>
        {
            orderType === CONSTANTS.TRANSFER &&
            <div className="transfer-asset-detail-block p-3">
                <div className="tranfer_asset_info">
                    <div>
                        <Label data-attribute="AssetDetail_Default_Label">Unit #</Label>
                        <Tooltip content={assetDetails?.unitNo || '-'} data-attribute="AssetDetail_Default_Tooltip">
                            <p>{assetDetails?.unitNo || '-'}</p>
                        </Tooltip>
                    </div>
                    <div>
                        <Label data-attribute="AssetDetail_Default_Label_2">License Plate #</Label>
                        <Tooltip content={assetDetails?.licenseNumber || '-'} data-attribute="AssetDetail_Default_Tooltip_2">
                            <p>{assetDetails?.licenseNumber || '-'}</p>
                        </Tooltip>
                    </div>
                    <div>
                        <Label data-attribute="AssetDetail_Default_Label_3">{assetDetails?.assetType == "vehicle" ? "VIN #" : "Serial #"}</Label>
                        <Tooltip content={assetDetails?.vinSerial || '-'} data-attribute="AssetDetail_Default_Tooltip_3">
                            <p>{assetDetails?.vinSerial || '-'}</p>
                        </Tooltip>
                    </div>    
                    <div>
                        <Label data-attribute="AssetDetail_Default_Label_4">Year</Label>
                        <Tooltip content={assetDetails?.year || '-'} data-attribute="AssetDetail_Default_Tooltip_4">
                            <p>{assetDetails?.year || '-'}</p>
                        </Tooltip>
                    </div>
                    <div>
                        <Label data-attribute="AssetDetail_Default_Label_5">Color</Label>
                        <Tooltip content={assetDetails?.color || '-'} data-attribute="AssetDetail_Default_Tooltip_5">
                            <p>{assetDetails?.color || '-'}</p>
                        </Tooltip>
                    </div>
                    <div>
                        <Label data-attribute="AssetDetail_Default_Label_6">GVW</Label>
                        <Tooltip content={assetDetails?.gvw || '-'} data-attribute="AssetDetail_Default_Tooltip_6">
                            <p>{assetDetails?.gvw || '-'}</p>
                        </Tooltip>
                    </div>
                    <div>
                        <Label data-attribute="AssetDetail_Default_Label_7">Equipment Class</Label>
                        <Tooltip content={assetDetails?.equipmentClass || '-'} data-attribute="AssetDetail_Default_Tooltip_7">
                            <p>{assetDetails?.equipmentClass || '-'}</p>
                        </Tooltip>
                    </div>
                    <div>
                        {attachmentBlock()}
                    </div>
                    <div>
                        <Label data-attribute="AssetDetail_Default_Label_8">Equipment Status</Label>
                        <Tooltip content={assetDetails?.equipmentStatus || '-'} data-attribute="AssetDetail_Default_Tooltip_8">
                            <p>{assetDetails?.equipmentStatus || '-'}</p>
                        </Tooltip>
                    </div>
                    <div>
                        <Label data-attribute="AssetDetail_Default_Label_9">Overall Condition</Label>
                        <Rating rating={parseInt(assetDetails?.overallConditionRating)} readOnly={true}  data-attribute="AssetDetail_Default_Rating" />
                        <Tooltip content={assetDetails?.overallConditionComments || '-'} data-attribute="AssetDetail_Default_Tooltip_9">
                            <p>{assetDetails?.overallConditionComments || '-'}</p>
                        </Tooltip>
                    </div>
                    {
                        assetDetails?.itemStatus === CONSTANTS?.ITEM_STATUS.CANCELLED &&
                        <div>
                            <Label data-attribute="AssetDetail_Default_Label_10">Cancel Comment</Label>
                            <Tooltip content={assetDetails?.cancelComments || '-'} data-attribute="AssetDetail_Default_Tooltip_10">
                                <p>{assetDetails?.cancelComments || '-'}</p>
                            </Tooltip>
                        </div>
                    }   
                </div>
                    <div className="receiving-branch-inputs">
                        <Label data-attribute="AssetDetail_Default_Label_11">Receiving Branch Inputs</Label>
                        <div className="content">
                            <div className="vin-serial-container">
                                <div className="vin-serial-no">
                                    <Label data-attribute="AssetDetail_Default_Label_12">VIN/Serial #</Label>
                                    <Tooltip content={formatLableValue(assetDetails?.receivingBranchDetails?.vinSerial)} data-attribute="AssetDetail_Default_Tooltip_11">
                                        <div>{formatLableValue(assetDetails?.receivingBranchDetails?.vinSerial)}</div>
                                    </Tooltip>
                                </div>
                                <div>
                                    <Label data-attribute="AssetDetail_Default_Label_13">VIN/Serial # Mismatch</Label>
                                    <Tooltip content={getBooleanYesNo(assetDetails?.receivingBranchDetails?.vinSerialMismatch)} data-attribute="AssetDetail_Default_Tooltip_12">
                                        <div>{getBooleanYesNo(assetDetails?.receivingBranchDetails?.vinSerialMismatch)}</div>
                                    </Tooltip>
                                </div>
                            </div>
                            <div className="vin-serial-container barcode-odometer-container">
                                <div className="vin-serial-no barcode-no">
                                    <Label data-attribute="AssetDetail_Default_Label_14">Barcode/Unit#</Label>
                                    <Tooltip content={formatLableValue(assetDetails?.receivingBranchDetails?.unitNo)} data-attribute="AssetDetail_Default_Tooltip_13">
                                        <div>{formatLableValue(assetDetails?.receivingBranchDetails?.unitNo)}</div>
                                    </Tooltip>
                                </div>
                                <div>
                                <Label data-attribute="AssetDetail_Default_Label_15">{assetDetails?.assetType == "vehicle" ? "Mileage" : assetDetails?.assetType == "mower" ? "Hour Meter" : "Odometer / Meter"}</Label>
                                        <Tooltip content={formatLableValue(assetDetails?.receivingBranchDetails?.odometerPHourMeter)} data-attribute="AssetDetail_Default_Tooltip_14">
                                        <div>{formatLableValue(assetDetails?.receivingBranchDetails?.odometerPHourMeter)}</div>
                                    </Tooltip>
                                </div>
                            </div>
                            <div className="vin-serial-container barcode-odometer-container">
                                <div className="vin-serial-no barcode-no">
                                    <Label data-attribute="AssetDetail_Default_Label_16">Fuel Card</Label>
                                    <Tooltip content={formatLableValue(assetDetails?.receivingBranchDetails?.fuelCard)} data-attribute="AssetDetail_Default_Tooltip_15">
                                        <div>{formatLableValue(assetDetails?.receivingBranchDetails?.fuelCard)}</div>
                                    </Tooltip>
                                </div>
                                <div>
                                    <Label data-attribute="AssetDetail_Default_Label_17">License Plate Tags</Label>
                                    <Tooltip content={assetDetails?.licensePlateTags ?? 'N/A'} data-attribute="AssetDetail_Default_Tooltip_16">
                                        <p>{assetDetails?.licensePlateTags ?? 'N/A'}</p>
                                    </Tooltip>
                                </div>
                            </div>
                            <div className="recieving_issues receieveBranchInputs">
                                <Label data-attribute="AssetDetail_Default_Label_18">Receiving Issues</Label>
                                {assetDetails?.receivingIssues ? ReceivingIssuesList(assetDetails?.receivingIssues) : 'N/A'}
                            </div>      
                        </div>
                    </div> 
            </div>
        }
        {
            orderType === CONSTANTS.DISPOSITION &&
            <div className="disposition-asset-detail-block p-3">
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_19">Unit #</Label>
                    <Tooltip content={assetDetails?.unitNo || '-'} data-attribute="AssetDetail_Default_Tooltip_17">
                        <p>{assetDetails?.unitNo || '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_20">License Plate #</Label>
                    <Tooltip content={assetDetails?.licenseNumber || '-'} data-attribute="AssetDetail_Default_Tooltip_18">
                        <p>{assetDetails?.licenseNumber || '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_21">{assetDetails?.assetType == "vehicle" ? "VIN #" : "Serial #"}</Label>
                    <Tooltip content={assetDetails?.vinSerial || '-'} data-attribute="AssetDetail_Default_Tooltip_19">
                        <p>{assetDetails?.vinSerial || '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_22">Year</Label>
                    <Tooltip content={assetDetails?.year || '-'} data-attribute="AssetDetail_Default_Tooltip_20">
                        <p>{assetDetails?.year || '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    {assetDetails?.dispositionPenaltyFee > 0 &&
                        <>
                            <Label data-attribute="AssetDetail_Default_Label_23">Write Off Penalty Fees</Label>
                            <Tooltip content={assetDetails?.isOverridePenaltyFee ? '$ 0.00' :  `$ ${formatPrice(assetDetails?.dispositionPenaltyFee, 2)}`} data-attribute="AssetDetail_Default_Tooltip_21">
                                <p>{assetDetails?.isOverridePenaltyFee ? '$ 0.00' :  `$ ${formatPrice(assetDetails?.dispositionPenaltyFee, 2)}`}</p>
                            </Tooltip>
                        </>
                    }
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_24">Color</Label>
                    <Tooltip content={assetDetails?.color || '-'} data-attribute="AssetDetail_Default_Tooltip_22">
                        <p>{assetDetails?.color || '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_25">GVW</Label>
                    <Tooltip content={assetDetails?.gvw || '-'} data-attribute="AssetDetail_Default_Tooltip_23">
                        <p>{assetDetails?.gvw || '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_26">{assetDetails?.assetType == "vehicle" ? "Mileage" : assetDetails?.assetType == "mower" ? "Hour Meter" : "Odometer / Meter"}</Label>
                    <Tooltip content={assetDetails?.odometerPHourMeter || '-'} data-attribute="AssetDetail_Default_Tooltip_24">
                        <p>{assetDetails?.odometerPHourMeter || '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_27">Equipment Class</Label>
                    <Tooltip content={assetDetails?.equipmentClass || '-'} data-attribute="AssetDetail_Default_Tooltip_25">
                        <p>{assetDetails?.equipmentClass || '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    {assetDetails?.dispositionPenaltyFee > 0 &&
                        <>
                            <Label data-attribute="AssetDetail_Default_Label_28">Override Penalty Fees</Label>
                            <SwitchToggle
                                onChange={handleOverridePenaltyFeeChange}
                                checked={assetDetails?.isOverridePenaltyFee}
                                disabled={!isSuperAdmin || assetDetails?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || assetDetails?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || isRequisitionComplete?.itemStatus == CONSTANTS.ITEM_STATUS.DISPOSITION_COMPLETE || assetDetails?.itemStatus == CONSTANTS.ITEM_STATUS.DISPOSITION_COMPLETE}
                             data-attribute="AssetDetail_Default_SwitchToggle" />
                        </>
                    }
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_29">Equipment Status</Label>
                    <Tooltip content={assetDetails?.equipmentStatus || '-'} data-attribute="AssetDetail_Default_Tooltip_26">
                        <p>{assetDetails?.equipmentStatus || '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_30">Estimated Disposal Price</Label>
                    <Tooltip content={assetDetails?.estimatedDispoValue != null ? `$${formatPrice(assetDetails?.estimatedDispoValue, 2)}` : '-'} data-attribute="AssetDetail_Default_Tooltip_27">
                        <p>{assetDetails?.estimatedDispoValue != null ? `$${formatPrice(assetDetails?.estimatedDispoValue, 2)}` : '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_31">Replacement Fleet Asset Order #</Label>
                    <Tooltip content={assetDetails?.replacementFleetAssetOrder || 'N/A'} data-attribute="AssetDetail_Default_Tooltip_28">
                        <p>{assetDetails?.replacementFleetAssetOrder || 'N/A'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_32">Replacement Fleet Asset #</Label>
                    <Tooltip content={assetDetails?.replacementFleetAsset || 'N/A'} data-attribute="AssetDetail_Default_Tooltip_29">
                        <p>{assetDetails?.replacementFleetAsset || 'N/A'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_33">Overall Condition</Label>
                    <Rating rating={parseInt(assetDetails?.overallConditionRating)} readOnly={true}  data-attribute="AssetDetail_Default_Rating_2" />
                    <Tooltip content={assetDetails?.overallConditionComments || '-'} data-attribute="AssetDetail_Default_Tooltip_30">
                        <p>{assetDetails?.overallConditionComments || '-'}</p>
                    </Tooltip>
                </div>
                {
                    assetDetails?.itemStatus === CONSTANTS?.ITEM_STATUS.CANCELLED &&
                    <div>
                        <Label data-attribute="AssetDetail_Default_Label_34">Cancel Comment</Label>
                        <Tooltip content={assetDetails?.cancelComments || '-'} data-attribute="AssetDetail_Default_Tooltip_31">
                            <p>{assetDetails?.cancelComments || '-'}</p>
                        </Tooltip>
                    </div>
                }
                <div>
                    {attachmentBlock()}
                </div>
                {assetDetails?.showAssetStatus ?
                    <div>
                        <Label data-attribute="AssetDetail_Default_Label_35">Asset Status</Label>
                        <Tooltip content={assetDetails?.assetStatus || '-'} data-attribute="AssetDetail_Default_Tooltip_32">
                            <p>{assetDetails?.assetStatus || '-'}</p>
                        </Tooltip>
                    </div>
                    : null}
                <div>
                    {(assetDetails?.dispositionPenaltyFee > 0 && assetDetails?.isOverridePenaltyFee) &&
                        <>
                            <Label required data-attribute="AssetDetail_Default_Label_36">Override Penalty Comment</Label>
                            <InputField
                                placeholder="Comment"
                                multiline={true}
                                resizable={false}
                                onChange={handleOverridePenaltyCommentChange}
                                onBlur={onBlurOverridePenaltyComment}
                                value={assetDetails?.overridePenaltyComment}
                                disabled={!isSuperAdmin || assetDetails?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || assetDetails?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || isRequisitionComplete?.itemStatus == CONSTANTS.ITEM_STATUS.DISPOSITION_COMPLETE || assetDetails?.itemStatus == CONSTANTS.ITEM_STATUS.DISPOSITION_COMPLETE}
                             data-attribute="AssetDetail_Default_Input" />
                            {!!penaltyCommentError?.length && <p className='validMessage'>{penaltyCommentError}</p>}
                        </>
                    }
                </div>
            </div>
        }
        {
            orderType === CONSTANTS.REACTIVATION &&

            <div className="reactivation-asset-detail-block p-3">
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_37">Unit #</Label>
                    <Tooltip content={assetDetails?.unitNo || '-'} data-attribute="AssetDetail_Default_Tooltip_33">
                        <p>{assetDetails?.unitNo || '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_38">License Plate #</Label>
                    <Tooltip content={assetDetails?.licenseNumber || '-'} data-attribute="AssetDetail_Default_Tooltip_34">
                        <p>{assetDetails?.licenseNumber || '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_39">Current License Plate #</Label>
                    <Tooltip content={assetDetails?.currentLicensePlateNo || '-'} data-attribute="AssetDetail_Default_Tooltip_35">
                        <p>{assetDetails?.currentLicensePlateNo || '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_40">{assetDetails?.assetType == "vehicle" ? "VIN #" : "Serial #"}</Label>
                    <Tooltip content={assetDetails?.vinSerial || '-'} data-attribute="AssetDetail_Default_Tooltip_36">
                        <p>{assetDetails?.vinSerial || '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_41">Year</Label>
                    <Tooltip content={assetDetails?.year || '-'} data-attribute="AssetDetail_Default_Tooltip_37">
                        <p>{assetDetails?.year || '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_42">Make</Label>
                    <Tooltip content={assetDetails?.make || '-'} data-attribute="AssetDetail_Default_Tooltip_38">
                        <p>{assetDetails?.make || '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_43">Model</Label>
                    <Tooltip content={assetDetails?.model || '-'} data-attribute="AssetDetail_Default_Tooltip_39">
                        <p>{assetDetails?.model || '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_44">Color</Label>
                    <Tooltip content={assetDetails?.color || '-'} data-attribute="AssetDetail_Default_Tooltip_40">
                        <p>{assetDetails?.color || '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_45">{assetDetails?.assetType == "vehicle" ? "Mileage" : assetDetails?.assetType == "mower" ? "Hour Meter" : "Odometer / Meter"}</Label>
                    <Tooltip content={assetDetails?.odometerPHourMeter || '-'} data-attribute="AssetDetail_Default_Tooltip_41">
                        <p>{assetDetails?.odometerPHourMeter || '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_46">Gain / Loss</Label>
                    <Tooltip content={assetDetails?.gainLoss != null ? assetDetails?.gainLoss?.toString().includes('-') ? '$ (' + (formatPrice(assetDetails?.gainLoss, 2)) + ')' : `$ ${formatPrice(assetDetails?.gainLoss, 2)}` : '-'} data-attribute="AssetDetail_Default_Tooltip_42">
                        <p>{assetDetails?.gainLoss != null ? assetDetails?.gainLoss?.toString().includes('-') ? '$ (' + (formatPrice(assetDetails?.gainLoss, 2)) + ')' : `$ ${formatPrice(assetDetails?.gainLoss, 2)}` : '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_47">Equipment Status</Label>
                    <Tooltip content={assetDetails?.equipmentStatus || '-'} data-attribute="AssetDetail_Default_Tooltip_43">
                        <p>{assetDetails?.equipmentStatus || '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_48">Disp Cost Center</Label>
                    <Tooltip content={assetDetails?.disposeCostCenter || '-'} data-attribute="AssetDetail_Default_Tooltip_44">
                        <p>{assetDetails?.disposeCostCenter || '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_49">Dispose Date</Label>
                    <Tooltip content={assetDetails?.disposeDate != null ? Moment(assetDetails?.disposeDate).format("MM/DD/YYYY")  : '-'} data-attribute="AssetDetail_Default_Tooltip_45">
                        <p>{assetDetails?.disposeDate != null ? Moment(assetDetails?.disposeDate).format("MM/DD/YYYY")  : '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_50">Equipment Class</Label>
                    <Tooltip content={assetDetails?.equipmentClass  || '-'} data-attribute="AssetDetail_Default_Tooltip_46">
                        <p>{assetDetails?.equipmentClass  || '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_51">Comment</Label>
                    <Tooltip content={assetDetails?.comments  || '-'} data-attribute="AssetDetail_Default_Tooltip_47">
                        <p>{assetDetails?.comments  || '-'}</p>
                    </Tooltip>
                </div>
                <div>
                    <Label data-attribute="AssetDetail_Default_Label_52">Asset Determination</Label>
                    <SwitchToggle
                        className="mt-2"
                        checked={assetDetails?.assetDetermination ? true : false}
                        onChange={(e: any, item?: any) => {onChangeAssetDetermination(e, item)}}
                        disabled = {assetDetails?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || assetDetails?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || isRequisitionComplete?.itemStatus == CONSTANTS.ORDER_STATUS.REACTIVATION_COMPLETE  || assetDetails?.itemStatus == CONSTANTS.ORDER_STATUS.REACTIVATION_COMPLETE || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
                     data-attribute="AssetDetail_Default_SwitchToggle_2" />
                </div>
                {assetDetails?.assetDetermination &&
                    <div>

                        <><Label required data-attribute="AssetDetail_Default_Label_53">New Asset #</Label>
                            <InputField
                                placeholder='Enter New Asset'
                                className={isNewAssetErrorExist?.length ? 'controlValidation' : ''}
                                onBlur={() => { onBlurNewAsset(assetDetails?.newAssetNumber) }}
                                onChange={(e?: any, item?: any) => { onChangeNewAsset(e, item) }}
                                value={assetDetails?.newAssetNumber ? assetDetails?.newAssetNumber : "" }
                                disabled={assetDetails?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || assetDetails?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || isRequisitionComplete?.itemStatus == CONSTANTS.ORDER_STATUS.REACTIVATION_COMPLETE || assetDetails?.itemStatus == CONSTANTS.ORDER_STATUS.REACTIVATION_COMPLETE || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
                             data-attribute="AssetDetail_Default_Input_2" />
                        </>
                        {newAssetErrorCheck(assetDetails?.fleetRequestDetailId)?.error?.length && <p className='validMessage'>{newAssetErrorCheck(assetDetails?.fleetRequestDetailId)?.error}</p>}
                    </div>
                }
                {
                    assetDetails?.itemStatus === CONSTANTS?.ITEM_STATUS.CANCELLED &&
                    <div>
                        <Label data-attribute="AssetDetail_Default_Label_54">Cancel Comment</Label>
                        <Tooltip content={assetDetails?.cancelComments || '-'} data-attribute="AssetDetail_Default_Tooltip_48">
                            <p>{assetDetails?.cancelComments || '-'}</p>
                        </Tooltip>
                    </div>
                }
                <div>
                    {attachmentBlock()}
                </div>
                {
                    Popupcontent.isDialogVisible && (
                        <CancelConfirmationPopup
                            hideDialog={!Popupcontent.isDialogVisible}
                            onDismiss={hideConfirmationDialog}
                            Popupcontent={Popupcontent}
                            popupOutlinebtnOnclick={() => Popupcontent?.popupOutlinebtnOnclick()}
                            popupPrimarybtnOnclick={() => Popupcontent?.popupPrimarybtnOnclick()}
                        />
                    )
                }
            </div>
        }

    </>)
}

export default AssetDetail;
